module.exports = __webpack_public_path__ + "img/banner_02.136c0877.png";